import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import {
  withPermission,
  Roles,
} from "../../../util/PermissionProvider";
import EditRemarksPage from "./EditRemarksPage";
import RemarksListingPage from "./RemarksListingPage";

export default function RemarksManagementPage(props) {
  const { match } = props;
  return (
    <Switch>
      <Route
        exact
        path={`${match.url}`}
        component={withPermission(
          RemarksListingPage,
          [Roles.SUPERADMIN, Roles.CINEFAN_EDITOR, Roles.CINEFAN_VIEWER],
          [Roles.SUPERADMIN, Roles.CINEFAN_EDITOR]
        )}
      />
      <Route
        path={`${match.url}/edit/:id`}
        component={withPermission(
          EditRemarksPage,
          [Roles.SUPERADMIN, Roles.CINEFAN_EDITOR, Roles.CINEFAN_VIEWER],
          [Roles.SUPERADMIN, Roles.CINEFAN_EDITOR]
        )}
      />
      <Route render={() => <Redirect to={`${match.url}`} />} />
    </Switch>
  );
}
